import { render } from "./TermOfUsePage.vue?vue&type=template&id=79bade6a&scoped=true"
const script = {}

import "./TermOfUsePage.vue?vue&type=style&index=0&id=79bade6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79bade6a"]])

export default __exports__